<div>
    <mat-drawer-container [hasBackdrop]="false" autosize style="height: calc(100vh - 50px); width:100%">
        <mat-drawer #drawer mode="side" opened style="display: block;">
            <mat-nav-list>
                <a *ngIf="aclGroup.mapping" [class]="redactionMapping ? 'navbar-items redactionMappingSelected mat-list-item mat-focus-indicator':'navbar-items mat-list-item mat-focus-indicator'" mat-list-item style="height: 30px;"><button mat-button style="height: 30px; font-size: 11pt; width: 100%;"
                    class="navbar-items" (click)="enableRedactionMapping()"> Redaction Mapping</button></a>
                <a *ngIf="aclGroup.profile" [class]="redactionProfiles ? 'navbar-items redactionMappingSelected mat-list-item mat-focus-indicator':'navbar-items mat-list-item mat-focus-indicator'" mat-list-item style="height: 30px;"><button mat-button style="height: 30px; font-size: 11pt;"
                        class="navbar-items" (click)="enableRedactionProfiles()"> Redaction Profiles</button></a>
            </mat-nav-list>
        </mat-drawer>

        <mat-drawer-content>
            <div class="mat-sidenav-content">
                <div class="container-fluid">
                    <div *ngIf="redactionMapping">
                        <app-redaction-mapping></app-redaction-mapping>
                    </div>

                    <div class="card border" *ngIf="redactionProfiles">
                        <app-redaction-profiles></app-redaction-profiles>
                    </div>
                </div>
            </div>
        </mat-drawer-content>
    </mat-drawer-container>
</div>